import type { ContractStatus, ProposalStatus } from '@pm/schemas';
import { Badge, type BadgeTone } from '@pm/ui';

export const PROPOSAL_LABEL: Record<ProposalStatus, string> = {
  DRAFT: 'Rascunho',
  SENT: 'Enviada',
  APPROVED: 'Aprovada',
  REJECTED: 'Rejeitada',
  EXPIRED: 'Expirada',
};
const PROPOSAL_TONE: Record<ProposalStatus, BadgeTone> = {
  DRAFT: 'neutral',
  SENT: 'info',
  APPROVED: 'success',
  REJECTED: 'danger',
  EXPIRED: 'warning',
};
export const CONTRACT_LABEL: Record<ContractStatus, string> = {
  DRAFT: 'Rascunho',
  ACTIVE: 'Ativo',
  SUSPENDED: 'Suspenso',
  ENDED: 'Encerrado',
  CANCELED: 'Cancelado',
};
const CONTRACT_TONE: Record<ContractStatus, BadgeTone> = {
  DRAFT: 'neutral',
  ACTIVE: 'success',
  SUSPENDED: 'warning',
  ENDED: 'neutral',
  CANCELED: 'danger',
};

export function ProposalBadge({ status }: { status: ProposalStatus }) {
  return <Badge tone={PROPOSAL_TONE[status]}>{PROPOSAL_LABEL[status]}</Badge>;
}
export function ContractBadge({ status }: { status: ContractStatus }) {
  return <Badge tone={CONTRACT_TONE[status]}>{CONTRACT_LABEL[status]}</Badge>;
}
